import { rgba } from './color.js';

const tau = Math.PI * 2;
const sparkleCount = 18;
const dustShare = 0.35;
const fadeRate = 2.5;

/** Visible sparkles per energy: a few while idle, a swarm while divining. */

const countRange = { min: 3, max: sparkleCount };

function createSparkle(index) {
  const angle = Math.random() * tau;
  const distance = Math.sqrt(Math.random()) * 0.88;

  return {
    x: Math.cos(angle) * distance,
    y: Math.sin(angle) * distance,
    dust: index / sparkleCount < dustShare,
    size: 0.02 + Math.random() * 0.045,
    phase: Math.random() * tau,
    twinkle: 1.5 + Math.random() * 2.5,
    drift: 0.2 + Math.random() * 0.4,
    alpha: 0,
  };
}

function drawStar(context, x, y, size) {
  context.beginPath();
  context.moveTo(x, y - size);
  context.quadraticCurveTo(x, y, x + size, y);
  context.quadraticCurveTo(x, y, x, y + size);
  context.quadraticCurveTo(x, y, x - size, y);
  context.quadraticCurveTo(x, y, x, y - size);
  context.fill();
}

function drawDot(context, x, y, size) {
  context.beginPath();
  context.arc(x, y, size * 0.25, 0, tau);
  context.fill();
}

/** Four-point stars twinkling and drifting inside the sphere, as in the loading frame. */

export function createSparkles() {
  const sparkles = Array.from({ length: sparkleCount }, (_, index) => createSparkle(index));

  function approach(sparkle, target, frame) {
    if (frame.still || !frame.delta) return target;

    const step = frame.delta * fadeRate;

    return sparkle.alpha + Math.max(Math.min(target - sparkle.alpha, step), -step);
  }

  return {
    resize() {},
    setState() {},
    destroy() {},

    render(context, frame) {
      const { width, height, radius, time, energy, settings } = frame;
      const centerX = width / 2;
      const centerY = height / 2;
      const count = Math.round(countRange.min + (countRange.max - countRange.min) * energy);

      sparkles.forEach((sparkle, index) => {
        sparkle.alpha = approach(sparkle, index < count ? 1 : 0, frame);

        if (sparkle.alpha <= 0) return;

        const shimmer =
          0.35 + 0.65 * (0.5 + 0.5 * Math.sin(time * sparkle.twinkle + sparkle.phase));
        const wander = time * sparkle.drift + sparkle.phase;
        const x = centerX + (sparkle.x + Math.sin(wander) * 0.05) * radius;
        const y = centerY + (sparkle.y + Math.cos(wander * 0.8) * 0.05) * radius;
        const size = sparkle.size * radius;
        const alpha = sparkle.alpha * shimmer * settings.intensity;

        context.fillStyle = rgba(sparkle.dust ? settings.accent : settings.spark, alpha);

        if (sparkle.dust) {
          drawDot(context, x, y, size);
          return;
        }

        drawStar(context, x, y, size);
        drawDot(context, x, y, size * 1.2);
      });
    },
  };
}
